module.exports = __webpack_public_path__ + "static/img/pdk-01.070dc685.jpg";